import { z } from 'zod';

export const PronounceSchema = z.object({
  language: z.string().optional().default('de'),
  text: z.string().min(1, 'Text cannot be empty'),
});

export type IPronounceDto = z.infer<typeof PronounceSchema>;
